@for (button of buttons(); track button.value) {
  <p-button
    styleClass="w-full"
    [size]="small() ? 'small' : undefined"
    [severity]="button.severity ?? 'primary'"
    [disabled]="button.disabled ?? false"
    [loading]="busyValue() === button.value"
    (onClick)="onSelect(button.value)">{{button.label}}</p-button>
}
